export const filterModes = {
  YEAR: "year",
  MONTH: "month",
  DAY: "day",
};

export const getInitialFilterMode = ({ fromDay, toDay, month }) => {
  if (fromDay || toDay) return filterModes.DAY;
  if (month) return filterModes.MONTH;
  return filterModes.YEAR;
};

export const getDateRangeFromFilters = (
  year,
  month,
  fromDay,
  toDay,
  monthOptions
) => {
  if (!year || !month || !fromDay || !toDay) return null;

  const monthIndex = monthOptions.indexOf(month);
  const startDate = new Date(
    parseInt(year, 10),
    monthIndex,
    parseInt(fromDay, 10)
  );
  const endDate = new Date(parseInt(year, 10), monthIndex, parseInt(toDay, 10));

  return [startDate, endDate];
};

export const sanitizeFilters = (filters) => {
  const { filterMode, ...rest } = filters;
  const clean = { ...rest, filterMode };

  if (filterMode === "By Year") {
    delete clean.month;
    // Keep startDate and endDate for year filtering
  } else if (filterMode === "By Date") {
    delete clean.year;
    delete clean.month;
  }
  // For 'By Month', do NOT delete startDate/endDate!

  return clean;
};
